import { t } from 'i18next';
import { scrollToSection } from '../../utils/scroll';

interface NavigationItemsProps {
  readonly className?: string;
  readonly onItemClick?: () => void;
}

export function NavigationItems({
  className,
  onItemClick,
}: NavigationItemsProps) {
  const items = [
    { sectionId: 'hero', label: t('header.navigation.home') },
    { sectionId: 'features', label: t('header.navigation.features') },
    { sectionId: 'pricing', label: t('header.navigation.pricing') },
    { sectionId: 'faq', label: t('header.navigation.faq') },
  ];

  const handleNavigation = (sectionId: string) => {
    scrollToSection(sectionId);
    onItemClick?.();
  };

  return (
    <>
      {items.map((item) => (
        <button
          key={item.sectionId}
          className={className}
          onClick={() => handleNavigation(item.sectionId)}
        >
          {item.label}
        </button>
      ))}
    </>
  );
}
